export default {
  // fieldでの絞り込みセレクトボックス作成用
  selectDataListFlag: false,
  // mypageでの絞り込みセレクトボックス作成用
  mySelectDataListFlag: false,
  // mypageでlocalStrageに絞り込みセレクトボックスデータがない時用
  myFieldDataApiFlag: false,
  // mypageで外部API呼んでる時用
  myApiKeyFlag: true,
  // ダイアログ用flag
  graphDialogFlag: false,
  // 右側生育状況用
  sensorDataFlag: false,
  // 右側生育(水遵守率)状況用
  waterComplianceRateFlag: false,
  // 一覧の詳細データ用
  fieldDetailsDataFlag: false,
  // モーダル一覧の詳細データ用
  fieldModalDetailsFlag: false,
  // グラフマスターデータ用
  graphMasterDataFlag: false,
  // 実績グラフデータ用
  graphActualDataFlag: false,
  // plantingId用
  setPlantingIdFlag: false,
  // グラフ年変更用
  graphChangeDisplayYear: false,
  // 詳細ダイアログ用フラグ
  growthDialogFlag: false,
  comparisonPlantFlag: false,
  comparisonMasterFlag: false,
  // 画像モーダル用flag
  imgFlag: false,
  // メイン画像モーダル用flag
  mainImgFlag: false,
  // グラフ設定モーダル用flag
  openSettingModalFlag: false
}
